import { create } from "zustand";
import type { Phase } from "../../api/types";

/** Menu d'une unité ouvert depuis la carte (clic droit, appui long au doigt ; docs/14 §2.1) : mission du temps
 *  affiché, « Position doctrinale », « Centrer », « Mesurer depuis cette unité ». `unit` est la clé de l'unité
 *  dans le déploiement ; `x`, `y` la position du pointeur dans la fenêtre. */
export type UnitMenuRequest = { unit: string; phase: Phase; x: number; y: number };

type UnitMenuState = {
  request: UnitMenuRequest | null;
  open: (request: UnitMenuRequest) => void;
  close: () => void;
};

export const useUnitMenu = create<UnitMenuState>()((set) => ({
  request: null,
  open: (request) => set({ request }),
  close: () => set({ request: null }),
}));
